/** API + DB values for business expenses (three buckets only). */
export const EXPENSE_CATEGORY_VALUES = {
  BOSS: 'boss',
  STAFF: 'staff',
  OFFICE: 'office',
};

export const EXPENSE_CATEGORY_OPTIONS = [
  { value: EXPENSE_CATEGORY_VALUES.BOSS, label: 'Boss (owner)' },
  { value: EXPENSE_CATEGORY_VALUES.STAFF, label: 'Staff' },
  { value: EXPENSE_CATEGORY_VALUES.OFFICE, label: 'Office' },
];

export function expenseCategoryLabel(value) {
  const v = String(value || '').toLowerCase();
  if (v === EXPENSE_CATEGORY_VALUES.BOSS) return 'Boss';
  if (v === EXPENSE_CATEGORY_VALUES.STAFF) return 'Staff';
  if (v === EXPENSE_CATEGORY_VALUES.OFFICE) return 'Office';
  return value || '—';
}
